export default {
    BASE_URL: import.meta.env.VITE_API_ENDPOINT,
    BASE_URL_V2: import.meta.env.VITE_API_ENDPOINT_V2,
    CLIENT_ID: import.meta.env.VITE_CLIENT_ID,
    FB_APP_ID: import.meta.env.VITE_FB_APP_ID,
    FB_KEY_SECRET: import.meta.env.VITE_FB_KEY_SECRET,
    CLIENT_SECRET: import.meta.env.VITE_CLIENT_SECRET,
    CLIENT_KEY: import.meta.env.VITE_CLIENT_KEY,
    PROJECT_APP: import.meta.env.VITE_PROJECT_APP,
    SITE_URL: import.meta.env.VITE_SITE_URL,
};
